export const getters = {
    currentSocietyRequest: state => state.currentSocietyRequest,
};
